var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2825 2.3333333333333335H0.7175A0.7175 0.7175 0 0 0 0 3.0508333333333337v7.898333333333333A0.7175 0.7175 0 0 0 0.7175 11.666666666666668h12.565A0.7175 0.7175 0 0 0 14 10.949166666666667V3.0508333333333337A0.7175 0.7175 0 0 0 13.2825 2.3333333333333335ZM5.833333333333334 8.300833333333333a0.49 0.49 0 0 1 -0.49 0.49H2.7533333333333334a0.4841666666666667 0.4841666666666667 0 0 1 -0.4841666666666667 -0.49V5.699166666666667a0.4841666666666667 0.4841666666666667 0 0 1 0.4841666666666667 -0.49h2.6075a0.49 0.49 0 0 1 0.49 0.49Zm5.751666666666667 0.5833333333333334h-3.5758333333333336a0.4375 0.4375 0 0 1 0 -0.875h3.5933333333333337a0.4375 0.4375 0 0 1 0 0.875Zm0 -2.1525000000000003h-3.5758333333333336a0.4375 0.4375 0 0 1 0 -0.875h3.5933333333333337a0.4375 0.4375 0 0 1 0 0.875Z",
    fill: "currentcolor",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCard);
export default __webpack_public_path__ + "static/media/businessCard.af25c6a0abd52568d29a59ebd32b9b71.svg";
export { ForwardRef as ReactComponent };